import React from 'react';

interface TabNavItemProps {
  id: string | number; 
  title: string;
  activeTab: string | number;
  setActiveTab: (id: string | number) => void;
  className?: string; 
  activeClass?: string;
}

export const TabNavItem: React.FC<TabNavItemProps> = ({ id, title, activeTab, setActiveTab, className = '', activeClass }) => {
  const handleClick = () => {
    setActiveTab(id);
  };

  return (
    <li
      onClick={handleClick}
      className={`${className} ${activeTab === id ? activeClass : ''}`}
    >
      {title}
    </li>
  );
};


interface TabContentProps {
  id: string | number;  
  activeTab: string | number;  
  children: React.ReactNode; 
  className?: string; 
}

export const TabContent: React.FC<TabContentProps> = ({ id, activeTab, children, className = '' }) => {
  return activeTab === id ? <div className={className}>{children}</div> : null;
};
